// Copyright © 2022 Olo Inc. All rights reserved.
// This software is made available under the Olo Pay SDK License (See LICENSE.md file)
import { WebPlugin } from '@capacitor/core';

import type {
  DigitalWalletStatus,
  DigitalWalletPaymentMethodResult,
  OloPaySDKPlugin,
  InternalInitOptions,
  InitializationStatus,
  DigitalWalletConfiguration,
  DigitalWalletPaymentRequestOptions,
  SdkInitializationOptions,
} from './definitions';
import { PromiseRejectionCode } from './definitions';

// NOTE: This web interface is required by the Capacitor Plugin, but it will not do anything
export class OloPaySDKWeb extends WebPlugin implements OloPaySDKPlugin {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  async updateDigitalWalletConfiguration(_options: { digitalWalletConfig: DigitalWalletConfiguration }): Promise<void> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'updateDigitalWalletConfiguration() is not implemented for web',
    });
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  async isDigitalWalletReady(): Promise<DigitalWalletStatus> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'isDigitalWalletReady() is not implemented for web',
    });
  }

  async createDigitalWalletPaymentMethod(
    _options: DigitalWalletPaymentRequestOptions,
  ): Promise<DigitalWalletPaymentMethodResult> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'createDigitalWalletPaymentMethod() is not implemented for web',
    });
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  async initialize(_options: SdkInitializationOptions): Promise<void> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'initialize() is not implemented for web',
    });
  }

  isInitialized(): Promise<InitializationStatus> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'isInitialized() is not implemented for web',
    });
  }
  isDigitalWalletInitialized(): Promise<InitializationStatus> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'isDigitalWalletInitialized() is not implemented for web',
    });
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  initializeInternal(_options: InternalInitOptions): Promise<void> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'isDigitalWalletInitialized() is not implemented for web',
    });
  }
}
